import CommentFeed from '../features/comments/CommentFeed';

export default function CommentsPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Müşteri Yorumları</h1>
          <p>Geri bildirimleri inceleyin, duygu durumunu etiketleyin ve öncelikli durumlara hızlıca yanıt verin.</p>
        </div>
      </header>
      <section className="page-section">
        <CommentFeed />
      </section>
    </div>
  );
}
